import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { turnIntoList, unwrapList } from 'common/Prose/utils'
import { computed } from 'mobx'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext, SelectionType } from 'stores/EditorState'

export function useVoteListToggle(view: EditorView): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const { schema } = view.state

  const selectionInVotelist = computed(() => almanacState.containingNodeTypes.has(schema.nodes.vote_list)).get()
  const selectionHasVotelist = computed(() => almanacState.activeNodes.has(schema.nodes.vote_list)).get()

  const handleVotelistClick = selectionInVotelist
    ? unwrapList(view, view.state.schema.nodes.vote_list)
    : turnIntoList(view, view.state.schema.nodes.vote_list)

  const isDisabled = almanacState.selectionType === SelectionType.Cell

  return { active: selectionHasVotelist, handleClick: handleVotelistClick, disabled: isDisabled }
}
